import React, { Component } from 'react';

import Content from '../Content';
import { Media, Render } from '../../components';
import Visible from '../Visible';
import * as Breakpoints from '../Breakpoints';

import classNames from 'classnames';

class Block extends Component {
  constructor(props) {
    super(props);
    this.state = {
      transform: null,
    };
  }

  componentDidMount() {
    let { block } = this.props;
    if (block.threeD) {
      window.addEventListener('mousemove', this.handleMouse);
    }
  }

  componentWillUnmount() {
    let { block } = this.props;
    if (block.threeD) {
      window.removeEventListener('mousemove', this.handleMouse);
    }
  }

  handleMouse = (evt) => {
    /*let {pageX,pageY} = evt
		let width = window.innerWidth
		let height = this.refs.block.offsetHeight

		let yAngle = -(0.5 - (pageX / width)) * 40; 
		let xAngle = (0.5 - (pageY / width)) * 40;

		*/

    //console.log(evt);

    //var x = 0.5;
    //var y = 0.5;
    var maxRotation = 6;
    //var perspective = 1000;

    var pos = [
      evt.clientX / window.innerWidth,
      evt.clientY / window.innerHeight,
    ];
    for (var i = 0; i < pos.length; i++) {
      if (pos[i] < 0) {
        pos[i] = 0;
      }
      if (pos[i] > 1) {
        pos[i] = 1;
      }
    }

    pos[0] = (pos[0] * 2 - 1) * maxRotation;
    pos[1] = (pos[1] * -2 + 1) * maxRotation;

    const transform = `transform: perspective(1000px) rotateX(${pos[1]}deg) rotateY(${pos[0]}deg)`;

    this.refs.effect.style = transform;
  };

  render() {
    let { block } = this.props;
    let blocks = [];

    if (!block) return null;

    let blockPadding = parseInt(block.padding, 10);

    switch (block.blockType) {
      case 'text':
        blocks = (
          <Visible>
            <Content modifier={'block'} html={block.text} />
          </Visible>
        );
        break;
      case 'image':
        let ratio = block.style === 'halfWidth' ? 800 / 800 : 1600 / 900;
        let mobileRatio = 1;

        if (block.videoWidth && block.videoHeight)
          ratio = block.videoWidth / block.videoHeight;
        if (block.mobileVideoWidth && block.mobileVideoHeight)
          mobileRatio = block.mobileVideoWidth / block.mobileVideoHeight;
        //blockPadding = block.padding / 100

        if (block.mobileAlternative) {
          blocks = (
            <div>
              <Breakpoints.Default>
                <Media
                  src={block.image}
                  poster={block.poster}
                  hasAudio={block.hasAudio}
                  kind={block.kind}
                  fluid={false}
                  ratio={ratio}
                  autoplay={true}
                  playOnVisible={false}
                  controls={false}
                />
              </Breakpoints.Default>
              <Breakpoints.Mobile>
                <Media
                  view="mobile"
                  src={block.mobileAlternative}
                  poster={block.mobilePoster}
                  hasAudio={block.hasAudio}
                  kind={block.kind}
                  fluid={false}
                  ratio={mobileRatio}
                  autoplay={true}
                  playOnVisible={false}
                  controls={false}
                />
              </Breakpoints.Mobile>
            </div>
          );
        } else {
          blocks = (
            <Media
              src={block.image}
              poster={block.poster}
              hasAudio={block.hasAudio}
              kind={block.kind}
              fluid={false}
              ratio={ratio}
              autoplay={true}
              playOnVisible={false}
              controls={false}
            />
          );
        }

        //blocks = <Media src={block.image} mobileSrc={block.mobileAlternative} poster={block.poster} hasAudio={block.hasAudio} kind={block.kind} fluid={false} ratio={ratio} autoplay={true} playOnVisible={false} controls={false}  />

        break;
      case 'vimeo':
        let vratio = block.style === 'halfWidth' ? 800 / 800 : 1600 / 900;
        //blockPadding = block.padding / 100
        //blocks = <Media src={block.url} poster={block.poster} hasAudio={block.hasAudio} kind={block.kind} fluid={false} ratio={vratio} autoplay={true} playOnVisible={false} controls={false}  />

        if (block.mobileAlternative) {
          blocks = (
            <div>
              <Breakpoints.Default>
                <Media
                  src={block.url}
                  poster={block.poster}
                  hasAudio={block.hasAudio}
                  kind={block.kind}
                  fluid={false}
                  ratio={vratio}
                  autoplay={true}
                  playOnVisible={false}
                  controls={false}
                />
              </Breakpoints.Default>
              <Breakpoints.Mobile>
                <Media
                  view="mobile"
                  src={block.mobileAlternative}
                  poster={block.mobilePoster}
                  hasAudio={block.hasAudio}
                  kind={block.kind}
                  fluid={false}
                  ratio={800 / 800}
                  autoplay={true}
                  playOnVisible={false}
                  controls={false}
                />
              </Breakpoints.Mobile>
            </div>
          );
        } else {
          blocks = (
            <Media
              src={block.url}
              poster={block.poster}
              hasAudio={block.hasAudio}
              kind={block.kind}
              fluid={false}
              ratio={vratio}
              autoplay={true}
              playOnVisible={false}
              controls={false}
            />
          );
        }

        break;
      case 'render':
        blocks = <Render settings={block} />;
        break;
      default:
    }

    let style = null;
    if (blockPadding) {
      blockPadding = blockPadding / 100;
      style = {
        transform: `scale(${blockPadding})`,
      };
    }

    let bg = null;
    if (block.backgroundColour) {
      bg = {
        backgroundColor: block.backgroundColour,
      };
    }

    let cls = classNames('Block', 'Block--' + block.blockType, {
      'Block--3d': block.threeD,
      'Block-no-padding': block.removeBottomPadding,
    });

    return (
      <div className={cls} style={bg}>
        <div className="Block-container" style={style} ref="block">
          <div className="Block-effect" ref="effect">
            {blocks}
          </div>
        </div>
      </div>
    );
  }
}

export default Block;



// WEBPACK FOOTER //
// ./src/js/components/Block/Block.js